import { useDimension } from '../../../../../../../util/useDimension.js';
import { useSelectContext } from '../../../hooks/useSelectContext.js';
import { useDirectionContext, Direction } from '../../../../../../../contexts/session/Locale.js';

var useSelectPopover = function useSelectPopover(props) {
  var width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    controlContainerRef = props.controlContainerRef;
  var _useSelectContext = useSelectContext(),
    triggerRef = _useSelectContext.triggerRef,
    state = _useSelectContext.state;
  var direction = useDirectionContext();
  var _useDimension = useDimension(controlContainerRef),
    controlContainerWidth = _useDimension.width;
  var offset = 12;
  if (!triggerRef || !state) return undefined;
  return {
    popoverProps: {
      state: state,
      triggerRef: triggerRef,
      placement: direction === Direction.RTL ? 'bottom end' : 'bottom start',
      width: width !== null && width !== void 0 ? width : "".concat(controlContainerWidth, "px"),
      minWidth: minWidth,
      maxWidth: maxWidth,
      offset: offset,
      crossOffset: direction === Direction.RTL ? offset : -offset
    }
  };
};

export { useSelectPopover };
//# sourceMappingURL=useSelectPopover.js.map
